import { StyledIcon } from 'src/components/foundations/foundations.styles';
import styled from 'styled-components';

export const StepperModalStyled = styled.dialog<{ $open?: boolean }>`
  display: ${(props) => (props.$open ? 'flex' : 'none')};
  flex-direction: column;
  min-height: 700px;
  padding: 0;
  border-radius: 4px;
  border: none;
  width: min(940px, 100vw);
  box-shadow:
    0px 0px 1px 0px rgba(0, 0, 0, 0.4),
    0px 12px 12px -6px rgba(0, 0, 0, 0.16);
  ::backdrop {
    background-color: #000000;
    opacity: 0.7;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  height: 700px;
  min-width: 940px;
  overflow-x: auto;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  width: 100%;
  padding: 0 20px;
`;

export const StepperContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 0 20px;
`;

export const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
`;

export const LeftButtons = styled.div`
  display: flex;
  gap: 20px;
`;

export const StyledCloseIcon = styled(StyledIcon)`
  position: absolute;
  top: 28px;
  left: 20px;
  cursor: pointer;
`;

export const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  max-height: 100%;
`;

export const ChildrenWrapper = styled.div<{ removePadding?: boolean }>`
  ${(props) => `padding: ${props.removePadding ? '0' : '20px 20px 60px 20px'}`};
`;
